export default "__VITE_ASSET__YJtWfiEW__"